import { Context } from "@nuxt/types/app";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  function getGridList(
    oldList: Array<Record<string, any>>,
    nCol = 4,
    isVerticalOrder = false,
  ) {
    const list: Array<Record<string, any>> = [];

    if (isVerticalOrder) {
      const nRow = Math.ceil(oldList.length / nCol);
      for (let i = 0; i < nRow; i++) {
        const row: Array<Record<string, unknown>> = [];
        for (let j = i; j < nRow * nCol; j += nRow) {
          row.push(oldList[j]);
        }
        list.push(row);
      }
      return list;
    }

    for (let i = 0; i < oldList.length; i += nCol) {
      const row: Array<Record<string, any>> = [];
      for (let j = i; j < i + nCol; j++) {
        row.push(oldList[j]);
      }
      list.push(row);
    }
    return list;
  }
  return {
    getGridList,
  };
}
